import { useRef, useState } from "react";
import { orderedLeafColumns } from "./columnDefs";
import { moveColumn } from "./tableLayout";
import { useDismiss } from "./useDismiss";
import { ICON_BUTTON, TOOLBAR_BUTTON } from "./styles";

const ColumnChooser = ({ table, onReset }) => {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const panelRef = useRef(null);
    useDismiss(open, [panelRef, buttonRef], () => setOpen(false));

    const columns = orderedLeafColumns(table).filter((column) => column.getCanHide());
    const visibleCount = columns.filter((column) => column.getIsVisible()).length;
    const titleOf = (column) => column.columnDef.meta?.config?.header || column.id;

    const move = (column, delta) => {
        const keys = columns.map((c) => c.id);
        const target = keys[keys.indexOf(column.id) + delta];
        if (target) table.setColumnOrder((order) => moveColumn(order, column.id, target));
    };

    return (
        <div className="relative">
            <button ref={buttonRef} type="button" className={TOOLBAR_BUTTON} aria-expanded={open} aria-haspopup="dialog" onClick={() => setOpen((value) => !value)}>
                Colunas
            </button>
            {open ? (
                <div ref={panelRef} role="dialog" aria-label="Escolher colunas" className="absolute right-0 z-20 mt-1 max-h-[360px] w-72 overflow-y-auto rounded border border-primary/40 bg-mgs-elevated p-2 text-left text-sm text-laranjinha shadow-lg">
                    <ul>
                        {columns.map((column, index) => (
                            <li key={column.id} className="flex items-center gap-2 py-1">
                                <label className="flex flex-1 items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={column.getIsVisible()}
                                        disabled={column.getIsVisible() && visibleCount === 1}
                                        onChange={column.getToggleVisibilityHandler()}
                                    />
                                    {titleOf(column)}
                                </label>
                                <button type="button" className={ICON_BUTTON} aria-label={`Mover ${titleOf(column)} para cima`} disabled={index === 0} onClick={() => move(column, -1)}>↑</button>
                                <button type="button" className={ICON_BUTTON} aria-label={`Mover ${titleOf(column)} para baixo`} disabled={index === columns.length - 1} onClick={() => move(column, 1)}>↓</button>
                            </li>
                        ))}
                    </ul>
                    <button type="button" className={`${TOOLBAR_BUTTON} mt-2 w-full`} onClick={() => { onReset?.(); setOpen(false); }}>
                        Restaurar colunas
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default ColumnChooser;
